<template>
  <slot />
  <template v-if="filter !== 'all'">
    <div>&rsaquo;</div>
    <a
      v-if="product"
      :href="$url(`/products?filter=${filter}`)"
    >
      {{ $t(`bundler.filters.${filter}`) }}
    </a>
    <div v-else>
      {{ $t(`bundler.filters.${filter}`) }}
    </div>
  </template>
  <template v-if="product">
    <div>&rsaquo;</div>
    <div>
      {{ product.title }}
    </div>
  </template>
  <template v-else-if="varietyPack">
    <div>&rsaquo;</div>
    <div>
      {{ varietyPack.title }}
    </div>
  </template>
</template>

<script setup lang="ts">
import { useProductsStore, useVarietyPacksStore } from '@/stores'
const { filter, product } = useProductsStore()
const { varietyPack } = useVarietyPacksStore()
</script>
